import styled from "@emotion/styled";
import { FC } from "react";
import { useSelector } from "react-redux";

import { Badge, SpacingToken } from "@livechat/design-system-react-components";

import { newFeaturesCampaigns } from "constants/campaigns";
import useNewReportsFeaturesCount from "hooks/reports/use-new-reports-features-count";
import useNewFeaturesCount from "hooks/settings/use-new-features-count";
import { useNewFeatureForAgents } from "hooks/use-new-feature-for-agents";
import { NavigationItems } from "interfaces/navigationItem";
import { IWithNavigationViewState, getNavigationItemBadge } from "store/views/navigation";
import { withVar } from "themes/helpers";

export const NavigationItemBadge: FC<{ itemId: string; accessAllowed: boolean }> = ({ itemId, accessAllowed }) => {
  const badgeContent = useSelector((state: IWithNavigationViewState) => getNavigationItemBadge(state, itemId));
  const settingsFeaturesCount = useNewFeaturesCount();
  const reportsFeaturesCount = useNewReportsFeaturesCount();
  const { isNewForAgent: isNewForAgentMarketplace, featureFlagValue: featureFlagValueMarketplace } =
    useNewFeatureForAgents(
      newFeaturesCampaigns.hasSeenMarketplace.flag,
      newFeaturesCampaigns.hasSeenMarketplace.campaignStartDate
    );
  const { isNewForAgent: isNewForAgentAutomations, featureFlagValue: featureFlagValueAutomations } =
    useNewFeatureForAgents(
      newFeaturesCampaigns.hasOpenedAutomationsAfterMacrosRelease.flag,
      newFeaturesCampaigns.hasOpenedAutomationsAfterMacrosRelease.campaignStartDate
    );

  if (!accessAllowed) {
    return null;
  }

  return (
    <>
      {badgeContent > 0 && <BadgeIcon size="compact" count={badgeContent} />}
      {itemId === NavigationItems.Marketplace && isNewForAgentMarketplace && !featureFlagValueMarketplace && (
        <BadgeIcon size="compact" type="dot" />
      )}
      {itemId === NavigationItems.Automations && isNewForAgentAutomations && !featureFlagValueAutomations && (
        <BadgeIcon size="compact" type="dot" />
      )}
      {itemId === NavigationItems.Settings && settingsFeaturesCount > 0 && (
        <BadgeIcon size="compact" count={settingsFeaturesCount} />
      )}
      {itemId === NavigationItems.Reports && reportsFeaturesCount > 0 && (
        <BadgeIcon size="compact" count={reportsFeaturesCount} />
      )}
    </>
  );
};

const BadgeIcon = styled(Badge)`
  position: absolute;
  pointer-events: none;
  top: ${withVar(SpacingToken.Spacing05)};
  right: ${withVar(SpacingToken.Spacing2)};
`;
